/* eslint-disable */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import cn from 'classnames';
import styles from './Print.scss';
import iconPrint from 'assets/images/icons/icon-print.svg';

import { setPopUp } from 'actions/environment';
import { loadPavilions } from 'actions/building';

import ReactTooltip from 'react-tooltip'

import PrintDialog from 'components/Building/PrintDialog'

class Print extends Component {

  componentDidMount() {
    ReactTooltip.rebuild()
  }

  handleClick = (e) => {
    if (!this.props.href) {
      e.preventDefault()
      const { loadPavilions, params, buildingInfo } = this.props;
      loadPavilions(params.id).then(
        () => {
          const { pavilions, chessList } = this.props.building
          if (!pavilions) return;
          this.props.setPopUp(
            <PrintDialog params={params} buildingInfo={buildingInfo} building={this.props.building}/>,
            {
                closeStyleName: 'Default',
                contentStyleName: 'Default',
                contentClassName: styles.PrintPopupContent,
                closeIcon: 'default',
                lockScroll: false
            }
          )
        }
      )
    }
  }

  render() {
    const { className, pure, href='#', tooltip } = this.props;
    return (
      <div className={cn(styles.PrintWrap, className, {[styles.Pure]: pure})} data-tip={tooltip} data-for="global">
        <a className={styles.ButtonPrint} href={href} target="_blank" onClick={this.handleClick.bind(this)}>
          <img src={iconPrint} alt=""/>
        </a>
      </div>
    );
  }
}

export default connect(
  null,
  {
    setPopUp,
    loadPavilions,
  }
)(Print);



// WEBPACK FOOTER //
// ./src/components/Building/Print/Print.js